import { z } from 'zod'

export const uploadFristDocumentSchema = z.object({
  expires_at: z.string().min(1, 'Ablaufdatum ist erforderlich'),
})

export type UploadFristDocumentInput = z.infer<typeof uploadFristDocumentSchema>

export const sendFristEmailSchema = z.object({
  to: z
    .string()
    .min(1, 'Empfänger ist erforderlich')
    .refine(
      (val) => val.split(',').map((s) => s.trim()).filter(Boolean).every((e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)),
      'Ungültige E-Mail-Adresse (mehrere mit Komma trennen)'
    ),
  subject: z.string().min(1, 'Betreff ist erforderlich'),
  message: z.string().optional(),
})

export type SendFristEmailInput = z.infer<typeof sendFristEmailSchema>

export const fristCategorySchema = z.object({
  name: z.string().min(1, 'Name ist erforderlich'),
})

export type FristCategoryInput = z.infer<typeof fristCategorySchema>
